module.exports = __webpack_public_path__ + "static/media/filter.fb6ef860.png";